import { ItemLayout } from "./ItemLayout";

export const ItemSkeleton = () => (
  <ItemLayout
    className="animate-pulse bg-background-secondary px-3 py-4"
    disabled
  />
);
